import React, { KeyboardEvent } from 'react'

import { Carat, RotateClockwise } from '@syconium/little-miss-figgy'

import { useTranslation } from '../../../../app/_providers/TranslationProvider.client'
import { NavLeftRight } from '../IProps'
import { LeftArrow, NavigationArrowsWrapper, RightArrow } from '../styles'

export const NavigationArrows: React.FC<NavLeftRight> = ({ gallerySwiperRef }) => {
  const {
    pages: {
      product: { gallery: strings },
    },
  } = useTranslation()

  const handlePrevClick = () => {
    gallerySwiperRef.current?.slidePrev(undefined, false)
  }

  const handleNextClick = () => {
    gallerySwiperRef.current?.slideNext(undefined, false)
  }

  const handleKeyDown = (event: KeyboardEvent) => {
    if (event.key === 'ArrowLeft') {
      event.preventDefault()
      handlePrevClick()
    } else if (event.key === 'ArrowRight') {
      event.preventDefault()
      handleNextClick()
    }
  }

  return (
    <NavigationArrowsWrapper>
      <LeftArrow
        forwardedAs='button'
        aria-label={strings.previousImage}
        onClick={handlePrevClick}
        onKeyDown={handleKeyDown}
      >
        <Carat height='18' rotateClockwise={RotateClockwise.Half} width='16' />
      </LeftArrow>
      <RightArrow
        forwardedAs='button'
        aria-label={strings.nextImage}
        onClick={handleNextClick}
        onKeyDown={handleKeyDown}
      >
        <Carat height='18' width='16' />
      </RightArrow>
    </NavigationArrowsWrapper>
  )
}
